import { CIcon } from '~/icons/types'

export const ciBuses: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm23.415 10.799-.74-4.38a.747.747 0 0 0-.05-.16c-.53-.95-3.21-1.2-3.56-1.2H1.575a1.5 1.5 0 0 0-1.5 1.5l.01 9.44a1.428 1.428 0 0 0 1.41 1.41h1.27a3.42 3.42 0 0 1-.04-.45 2.974 2.974 0 0 1 .91-2.2 3.01 3.01 0 0 1 2.09-.84h.16a2.982 2.982 0 0 1 1.93.86c.524.5.845 1.177.9 1.9a3.4 3.4 0 0 1-.02.72h6.33a3.005 3.005 0 1 1 5.93 0h2.48a.5.5 0 0 0 .35-.14.518.518 0 0 0 .14-.35v-.49a37.8 37.8 0 0 0-.51-5.62Zm-16.91.78h-3.84v-3.9h3.84v3.9Zm4.83 0h-3.85v-3.9h3.85v3.9Zm4.36 0h-3.37v-3.9H15.7l-.005 3.9Zm5.01.65a17.757 17.757 0 0 0-4.03-.62V7.667l5.29.01.48 3.27c.11.64.2 1.29.27 1.93l-2.01-.648Z'
    },
    {
      d:
        'M17.981 14.906a2.02 2.02 0 0 0-2.02 2.02 2.018 2.018 0 1 0 2.02-2.02Zm-12.145 0h-.1a2.02 2.02 0 0 0-.09 4.036h.085A2.016 2.016 0 0 0 7.655 17.5l.028-.1c.052-.208.07-.423.05-.637a2.044 2.044 0 0 0-1.897-1.857Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'buses',
  type: 'solid'
}
